import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["error", "title", "name", "label", "disabled", "defaultChecked", "required", "vwScale"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
import ErrorMessage from "./ErrorMessage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SingleCheckboxField = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames, _classnames2;

  var error = props.error,
      title = props.title,
      name = props.name,
      label = props.label,
      disabled = props.disabled,
      defaultChecked = props.defaultChecked,
      required = props.required,
      vwScale = props.vwScale,
      _props = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, (_classnames = {}, _defineProperty(_classnames, styles.required, required), _defineProperty(_classnames, styles.vwScale, vwScale), _classnames)),
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.checkbox, (_classnames2 = {}, _defineProperty(_classnames2, styles.disabled, disabled), _defineProperty(_classnames2, styles.vwScale, vwScale), _classnames2)),
      children: [/*#__PURE__*/_jsx("input", _objectSpread({
        ref: ref,
        id: "checkbox-".concat(name),
        name: name,
        type: "checkbox",
        defaultChecked: defaultChecked
      }, _props)), /*#__PURE__*/_jsx("label", {
        htmlFor: "checkbox-".concat(name),
        className: styles.label,
        tabIndex: "0",
        children: /*#__PURE__*/_jsx("span", {
          children: label
        })
      })]
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
});
SingleCheckboxField.displayName = "SingleCheckboxField";
export default SingleCheckboxField;